import { NavGroup, NavPageItem } from '../types';
import { isDocsAdmin } from './roles';

export interface AccessContext {
  isAuthenticated: boolean;
  roles?: string[] | null;
  isAdmin?: boolean;
}

export type NavItem = NavPageItem | NavGroup;

export function isNavGroup(item: NavItem): item is NavGroup {
  return 'group' in item && Array.isArray((item as NavGroup).pages);
}

export function canAccess(access: string[] | undefined, context: AccessContext): boolean {
  const required = access ?? ['public'];
  if (required.length === 0 || required.includes('public')) return true;
  if (!context.isAuthenticated) return false;
  if (required.includes('authenticated')) return true;
  const userRoles = context.roles || [];
  return (
    required.some((group) => userRoles.includes(group)) ||
    Boolean(context.isAdmin) ||
    isDocsAdmin(userRoles)
  );
}

/** Drops pages and groups the user cannot open, and any group left without pages. */
export function filterNavByAccess<T extends NavItem>(items: T[], context: AccessContext): T[] {
  const visible: T[] = [];
  for (const item of items) {
    if (!canAccess(item.access, context)) continue;
    if (isNavGroup(item)) {
      const pages = filterNavByAccess(item.pages, context);
      if (pages.length === 0) continue;
      visible.push({ ...item, pages });
    } else {
      visible.push(item);
    }
  }
  return visible;
}